import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ModalDefaultDraggable } from '../../../molecules';
import AddJurisdictionContainer from './AddJurisdictionContainer';
import { RootState } from '../../../redux/root';
import { setAddJuristdictionOpen } from '../../../redux/slices/wikiSlice';

const AddJurisdictionPopup = () => {
  const addJuristdictionOpen = useSelector((s:RootState) => s.wikiSlice.addJuristdictionOpen);
  const dispatch = useDispatch();
  const onClose = () => {
    dispatch(setAddJuristdictionOpen(false));
  };
  return (
    <div>
      {addJuristdictionOpen && (
        <ModalDefaultDraggable onClose={onClose} title="Add Jurisdiction" wide>
          <AddJurisdictionContainer onClose={onClose} />
        </ModalDefaultDraggable>
      )}
    </div>
  );
};

export default AddJurisdictionPopup;
